module.exports = __webpack_public_path__ + "img/login_bg.3ab48d54.png";